import i18n from 'i18next'
import backend from 'i18next-http-backend'
import {initReactI18next, useTranslation} from 'react-i18next'

i18n
  .use(backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // debug: true,
    lng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    fallbackLng: false, // use en if detected lng is not available
    // saveMissing: false, // send not translated keys to endpoint
    // backend: {
    //   loadPath: (lng: string, ns: string) => {
    //     const company = localStorage.getItem('company') || 'default'
    //     return `/locales/${company}/${lng}.json`
    //   },
    // },
    returnNull: false, // show key if missing
    returnEmptyString: false, // show key if empty
    resources: {},
  })

export default i18n
let tenantOverrides: Record<string, string> = {}

export function setOverrides(overrides: Record<string, string>) {
  tenantOverrides = overrides || {}
}

export function getOverrides() {
  return tenantOverrides
}
export function replaceWords(text: string) {
  if (!text) return text

  let result = text
  const overrides = getOverrides()

  for (const key in overrides) {
    const regex = new RegExp(`\\b${key}\\b`, 'gi')
    result = result.replace(regex, overrides[key])
  }

  return result
}

export async function switchCompany(companySlug: string, lang = 'en') {
  try {
    const response = await fetch(`/locales/${companySlug}/${lang}.json`)
    const translations = await response.json()
    setOverrides(translations)

    // Replace previous bundle for the language (company based)
    i18n.addResourceBundle(lang, 'translation', translations, true, true)

    // Change language to trigger rerender
    await i18n.changeLanguage(lang)
  } catch (err) {
    console.error('Error loading translations', err)
  }
}

export function useTenantT() {
  const {t} = useTranslation()

  return (label: string) => {
    // Try normal i18n translation first
    const translated = t(label)

    // i18n returns the key itself if no translation exists → raw string
    const isMissingKey = translated === label

    return isMissingKey ? replaceWords(label) : translated
  }
}
